/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Issues } from './issues';
import { EntityTypeEnum } from './entityTypeEnum';


export interface UpgradeFailedSpec { 
    /**
     * Id of entity passed in request body.
     */
    id: string;
    entity_type: EntityTypeEnum;
    issues: Issues;
}
export namespace UpgradeFailedSpec {
}


